import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { OtherInfo } from './otherinfo.model';

@Injectable({
  providedIn: 'root'
})
export class OtherinfoService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }


  getAll(status: number) {
    return this.http.get<OtherInfo[]>(this.global.APIURL + "otherinfo?status=" + status);
  }

  getById(id: number) {
    return this.http.get<OtherInfo>(this.global.APIURL + "otherinfo/" + id);
  }

  Create(obj: object) {
    return this.http.post(this.global.APIURL + "otherinfo", obj)
  }

  Update(obj: any) {
    return this.http.put(this.global.APIURL + "otherinfo", obj)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "otherinfo/" + id)
  }
}
